"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.roomEntitiesSelector = exports.getWaitingRoomMembersByRoomIdSelector = exports.getUserIsAdminByCurrentUserIdSelector = exports.getUniqRoomUsersWithoutMeByRoomIdSelector = exports.getUniqRoomMembersWithoutMeOrCallerByRoomIdSelectorLight = exports.getUniqRoomMembersWithoutMeOrCallerByRoomIdSelector = exports.getRoomsLoaded = exports.getRooms = exports.getRoomTypeByRoomIdSelector = exports.getRoomMembersWithoutMyDeviceByRoomIdSelector = exports.getRoomMembersWithoutKickedByRoomIdSelector = exports.getRoomMembersByRoomIdSelector = exports.getRoomMemberWithoutKickedsAndMyDeviceByRoomIdSelector = exports.getRoomMemberIdsByRoomIdSelector = exports.getRoomMemberCountByRoomIdSelector = exports.getRoomMemberByUserIdSelector = exports.getRoomMemberByClientIdSelector = exports.getRoomInitiatorByRoomIdSelector = exports.getRoomIdsSortByConnectedMemberSelector = exports.getRoomDisplayModeByRoomIdSelector = exports.getRoomByIdSelector = exports.getRingingRoomsSelector = exports.getMyRoomStreamInfoByRoomIdSelector = exports.getMyClientAsARoomMemberSelector = exports.getMeAsRoomMemberSelector = exports.getHoldRoomSelector = exports.getForwardableRoomsSelector = exports.getFocusedUserByRoomId = exports.getFeedIdByRoomIdSelector = exports.getEndedRoomsSelector = exports.getDisplayRoomNameSelector = exports.getDisplayRoomNameInListSelector = exports.getCurrentByUserRoomsSelector = exports.getCurrentByClientRoomsSelector = exports.getConnectedRoomMembersWithoutMyDeviceByRoomIdSelectorLight = exports.getConnectedRoomMembersWithoutMyDeviceByRoomIdSelector = exports.getConnectedRoomMembersByRoomIdSelector = exports.getConnectedRoomMemberClientIdsWithoutMeByRoomIdSelector = exports.getConnectedRoomMemberClientIdsByRoomIdSelector = exports.getAwayRoomMembersByRoomIdSelector = exports.getAwayRoomMemberIdsByRoomIdSelector = exports.currentRoomSettingsSelector = exports.currentRoomSelector = exports._roomsSelector = exports._notInProgressRooms = exports._inProgressUnicastRooms = exports._inProgressRooms = exports._inProgressMulticastRooms = exports._currentRoomSelector = exports._currentRingingRoomSelector = exports._currentActiveRoomSelector = void 0;
var _reselect = require("reselect");
var _selectors = require("../session/selectors");
var _selectors2 = require("../entities/selectors");
var _middlewares = require("./middlewares");
var _constants = require("./constants");
var _i18n = _interopRequireDefault(require("../../utils/i18n"));
var _uniqBy = _interopRequireDefault(require("lodash/uniqBy"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var getLightMember = function getLightMember() {
  var {
    peerState,
    status,
    fullname,
    firstname,
    lastname,
    avatarUri,
    title,
    isAdmin,
    isCaller,
    phonenumber,
    _user,
    _client
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    peerState,
    status,
    fullname,
    firstname,
    lastname,
    avatarUri,
    title,
    isAdmin,
    isCaller,
    phonenumber,
    _user,
    _client
  };
};
var roomEntitiesSelector = state => (0, _selectors2.entitiesSelector)(state).rooms;
exports.roomEntitiesSelector = roomEntitiesSelector;
var _getClientParameter = (state, _room, _client) => _client;
var _getRoomParameter = (state, _room) => _room;
var _getUserParameter = (state, _room, _user) => _user;
var _currentRoomSelector = state => (state.rooms.currentByClient || [])[0];
exports._currentRoomSelector = _currentRoomSelector;
var _currentRingingRoomSelector = state => (state.rooms.ringing || [])[0];
exports._currentRingingRoomSelector = _currentRingingRoomSelector;
var _roomsSelector = state => state.rooms.items;
exports._roomsSelector = _roomsSelector;
var _currentActiveRoomSelector = state => state.rooms._currentActive;
exports._currentActiveRoomSelector = _currentActiveRoomSelector;
var currentRoomSelector = state => {
  var _currentRooms = state.rooms.currentByClient;
  if (_currentRooms && _currentRooms.length) {
    return (0, _selectors2.entitiesSelector)(state).rooms[_currentRooms[0]];
  }
  return undefined;
};
exports.currentRoomSelector = currentRoomSelector;
var currentRoomSettingsSelector = state => state.rooms;
exports.currentRoomSettingsSelector = currentRoomSettingsSelector;
var getCurrentByClientRoomsSelector = state => state.rooms.currentByClient;
exports.getCurrentByClientRoomsSelector = getCurrentByClientRoomsSelector;
var getCurrentByUserRoomsSelector = state => state.rooms.currentByUser;
exports.getCurrentByUserRoomsSelector = getCurrentByUserRoomsSelector;
var getEndedRoomsSelector = state => state.rooms.ended;
exports.getEndedRoomsSelector = getEndedRoomsSelector;
var getRingingRoomsSelector = state => state.rooms.ringing;
exports.getRingingRoomsSelector = getRingingRoomsSelector;
var getRoomByIdSelector = exports.getRoomByIdSelector = (0, _reselect.createSelector)([_getRoomParameter, roomEntitiesSelector], (_room, rooms) => rooms === null || rooms === void 0 ? void 0 : rooms[_room]);
var getRoomIdsSortByConnectedMemberSelector = exports.getRoomIdsSortByConnectedMemberSelector = (0, _reselect.createSelector)([_roomsSelector, roomEntitiesSelector, _selectors.getUserId], (_rooms, rooms, _myUser) => {
  var _ref;
  return (// If the contents of an array have not changed, reselect will return the previous reference.
    // In the case of sorting, this is a problem for us, so we have to make it immutable.
    (_ref = [..._rooms]) === null || _ref === void 0 ? void 0 : _ref.sort((a, b) => {
      var _aM$filter, _bM$filter;
      var {
        members: aM = [],
        name: aN
      } = rooms === null || rooms === void 0 ? void 0 : rooms[a];
      var {
        members: bM = [],
        name: bN
      } = rooms === null || rooms === void 0 ? void 0 : rooms[b];
      var aIsLive = !!(aM !== null && aM !== void 0 && (_aM$filter = aM.filter(_ref2 => {
        var {
          status
        } = _ref2;
        return (0, _middlewares.isJoinedOrHoldMember)(status);
      })) !== null && _aM$filter !== void 0 && _aM$filter.length);
      var bIsLive = !!(bM !== null && bM !== void 0 && (_bM$filter = bM.filter(_ref3 => {
        var {
          status
        } = _ref3;
        return (0, _middlewares.isJoinedOrHoldMember)(status);
      })) !== null && _bM$filter !== void 0 && _bM$filter.length);
      if (aIsLive > bIsLive) {
        return -1;
      }
      if (aIsLive < bIsLive) {
        return 1;
      }
      var aU = aM.find(_ref4 => {
        var {
          _user
        } = _ref4;
        return _user === _myUser;
      }) || {};
      var bU = bM.find(_ref5 => {
        var {
          _user
        } = _ref5;
        return _user === _myUser;
      }) || {};
      if (aU.joinedAt > bU.joinedAt) {
        return -1;
      }
      if (aU.joinedAt < bU.joinedAt) {
        return 1;
      }
      if (aU.invitedAt > bU.invitedAt) {
        return -1;
      }
      if (aU.invitedAt < bU.invitedAt) {
        return 1;
      }
      var nameA = aN ? aN.toLowerCase() : undefined;
      var nameB = bN ? bN.toLowerCase() : undefined;
      if (!nameA) return 1;
      if (!nameB) return -1;
      return nameA >= nameB ? 1 : -1;
    })
  );
});
var getHoldRoomSelector = exports.getHoldRoomSelector = (0, _reselect.createSelector)([roomEntitiesSelector], rooms => {
  var holdRooms = [];
  for (var _room in rooms) {
    var _rooms$_room;
    if (rooms !== null && rooms !== void 0 && (_rooms$_room = rooms[_room]) !== null && _rooms$_room !== void 0 && _rooms$_room.isHold) {
      holdRooms.push(rooms === null || rooms === void 0 ? void 0 : rooms[_room]);
    }
  }
  return holdRooms;
});
var getMyRoomStreamInfoByRoomIdSelector = exports.getMyRoomStreamInfoByRoomIdSelector = (0, _reselect.createSelector)([getRoomByIdSelector], room => room === null || room === void 0 ? void 0 : room.myStream);
var getFocusedUserByRoomId = exports.getFocusedUserByRoomId = (0, _reselect.createSelector)([getRoomByIdSelector], room => room === null || room === void 0 ? void 0 : room.focusOn);
var getRoomInitiatorByRoomIdSelector = exports.getRoomInitiatorByRoomIdSelector = (0, _reselect.createSelector)([getRoomByIdSelector], room => room === null || room === void 0 ? void 0 : room.caller);
var getRoomMembersByRoomIdSelector = exports.getRoomMembersByRoomIdSelector = (0, _reselect.createSelector)([getRoomByIdSelector], room => (room === null || room === void 0 ? void 0 : room.members) || []);
var getForwardableRoomsSelector = exports.getForwardableRoomsSelector = (0, _reselect.createSelector)([_getRoomParameter, roomEntitiesSelector], (_room, rooms) => {
  var _rooms$_room2;
  var destRooms = [];
  var transferTag = rooms === null || rooms === void 0 || (_rooms$_room2 = rooms[_room]) === null || _rooms$_room2 === void 0 || (_rooms$_room2 = _rooms$_room2.features) === null || _rooms$_room2 === void 0 ? void 0 : _rooms$_room2.transfers;
  if (transferTag) {
    for (var _destRoom in rooms) {
      var _rooms$_destRoom;
      var transferTagDest = rooms === null || rooms === void 0 || (_rooms$_destRoom = rooms[_destRoom]) === null || _rooms$_destRoom === void 0 || (_rooms$_destRoom = _rooms$_destRoom.features) === null || _rooms$_destRoom === void 0 ? void 0 : _rooms$_destRoom.transfers;
      if (transferTag && transferTagDest && (transferTagDest === transferTag || [transferTagDest, transferTag].includes(_constants.ROOM_TRANSFER_TYPES.ALL)) && _destRoom !== _room) {
        destRooms.push(rooms === null || rooms === void 0 ? void 0 : rooms[_destRoom]);
      }
    }
  }
  return destRooms;
});
var getRoomMembersWithoutMyDeviceByRoomIdSelector = exports.getRoomMembersWithoutMyDeviceByRoomIdSelector = (0, _reselect.createSelector)([getRoomMembersByRoomIdSelector, _selectors._currentClientSelector], (members, _myClient) => members.filter(e => e._client !== _myClient && !e.isMe));
var getRoomMemberIdsByRoomIdSelector = exports.getRoomMemberIdsByRoomIdSelector = (0, _reselect.createSelector)([getRoomMembersByRoomIdSelector], members => members.map(_ref6 => {
  var {
    id
  } = _ref6;
  return id;
}));
var getConnectedRoomMembersByRoomIdSelector = exports.getConnectedRoomMembersByRoomIdSelector = (0, _reselect.createSelector)([getRoomMembersByRoomIdSelector], members => members === null || members === void 0 ? void 0 : members.filter(_ref7 => {
  var {
    status
  } = _ref7;
  return (0, _middlewares.isJoinedOrHoldMember)(status);
}));
var getRoomMembersWithoutKickedByRoomIdSelector = exports.getRoomMembersWithoutKickedByRoomIdSelector = (0, _reselect.createSelector)([getRoomMembersByRoomIdSelector], members => members === null || members === void 0 ? void 0 : members.filter(_ref8 => {
  var {
    status
  } = _ref8;
  return status !== _constants.USER_IN_ROOM_STATUS.KICKED;
}));
var getConnectedRoomMembersWithoutMyDeviceByRoomIdSelector = exports.getConnectedRoomMembersWithoutMyDeviceByRoomIdSelector = (0, _reselect.createSelector)([getRoomMembersWithoutMyDeviceByRoomIdSelector], members => members === null || members === void 0 ? void 0 : members.filter(_ref9 => {
  var {
    status
  } = _ref9;
  return (0, _middlewares.isJoinedOrHoldMember)(status);
}));
var getRoomMemberWithoutKickedsAndMyDeviceByRoomIdSelector = exports.getRoomMemberWithoutKickedsAndMyDeviceByRoomIdSelector = (0, _reselect.createSelector)([getRoomMembersWithoutMyDeviceByRoomIdSelector], members => members === null || members === void 0 ? void 0 : members.filter(_ref10 => {
  var {
    status
  } = _ref10;
  return status !== _constants.USER_IN_ROOM_STATUS.KICKED;
}));
var getUniqRoomUsersWithoutMeByRoomIdSelector = exports.getUniqRoomUsersWithoutMeByRoomIdSelector = (0, _reselect.createSelector)([getRoomMembersByRoomIdSelector, _selectors.getUserId], (members, _myUser) => (0, _uniqBy.default)(members === null || members === void 0 ? void 0 : members.filter(_ref11 => {
  var {
    _user
  } = _ref11;
  return _user !== _myUser;
}), '_user'));
var getUniqRoomMembersWithoutMeOrCallerByRoomIdSelector = exports.getUniqRoomMembersWithoutMeOrCallerByRoomIdSelector = (0, _reselect.createSelector)([getRoomMembersByRoomIdSelector, _selectors.getUserId], (members, _myUser) => (0, _uniqBy.default)(members === null || members === void 0 ? void 0 : members.filter(_ref12 => {
  var {
    isCaller,
    _user
  } = _ref12;
  return !isCaller && _user !== _myUser;
}), '_user'));
var getUniqRoomMembersWithoutMeOrCallerByRoomIdSelectorLight = exports.getUniqRoomMembersWithoutMeOrCallerByRoomIdSelectorLight = (0, _reselect.createSelector)([getUniqRoomMembersWithoutMeOrCallerByRoomIdSelector], members => (0, _uniqBy.default)(members === null || members === void 0 ? void 0 : members.map(getLightMember), '_user'));
var getConnectedRoomMembersWithoutMyDeviceByRoomIdSelectorLight = exports.getConnectedRoomMembersWithoutMyDeviceByRoomIdSelectorLight = (0, _reselect.createSelector)([getRoomMembersWithoutMyDeviceByRoomIdSelector], members => members.reduce((acc, member) => {
  if ((0, _middlewares.isJoinedOrHoldMember)(member.status)) {
    acc.push(getLightMember(member));
  }
  return acc;
}, []));
var getRoomMemberCountByRoomIdSelector = exports.getRoomMemberCountByRoomIdSelector = (0, _reselect.createSelector)([getConnectedRoomMembersByRoomIdSelector], members => (members === null || members === void 0 ? void 0 : members.length) || 0);
var getRoomMemberByClientIdSelector = exports.getRoomMemberByClientIdSelector = (0, _reselect.createSelector)([getRoomMembersByRoomIdSelector, _getClientParameter], (members, _client) => members === null || members === void 0 ? void 0 : members.find(member => member._client === _client));
var getConnectedRoomMemberClientIdsByRoomIdSelector = exports.getConnectedRoomMemberClientIdsByRoomIdSelector = (0, _reselect.createSelector)([getConnectedRoomMembersByRoomIdSelector], members => members === null || members === void 0 ? void 0 : members.map(member => member._client));
var getConnectedRoomMemberClientIdsWithoutMeByRoomIdSelector = exports.getConnectedRoomMemberClientIdsWithoutMeByRoomIdSelector = (0, _reselect.createSelector)([getConnectedRoomMemberClientIdsByRoomIdSelector, _selectors._currentClientSelector], (_members, _client) => _members === null || _members === void 0 ? void 0 : _members.filter(id => id !== _client));
var getAwayRoomMembersByRoomIdSelector = exports.getAwayRoomMembersByRoomIdSelector = (0, _reselect.createSelector)([getRoomMembersByRoomIdSelector], members => {
  var _members$filter;
  return members === null || members === void 0 || (_members$filter = members.filter) === null || _members$filter === void 0 ? void 0 : _members$filter.call(members, _ref13 => {
    var {
      status
    } = _ref13;
    return status === _constants.USER_IN_ROOM_STATUS.WAITING || status === _constants.USER_IN_ROOM_STATUS.LEFT || status === _constants.USER_IN_ROOM_STATUS.MISSED;
  });
});
var getDisplayRoomNameFromMembersSelector = (0, _reselect.createSelector)([getRoomByIdSelector, _selectors.getUserId], (room, _me) => {
  var name;
  if (!room) return '';
  if (room !== null && room !== void 0 && room.members) {
    var roomMembersWithoutMe = room.members.filter(e => (e === null || e === void 0 ? void 0 : e._user) !== _me);
    if (!room.isMulticast && roomMembersWithoutMe.length > 0) {
      name = roomMembersWithoutMe === null || roomMembersWithoutMe === void 0 ? void 0 : roomMembersWithoutMe.map(function () {
        var {
          firstname,
          phonenumber
        } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return firstname || phonenumber;
      }).join(', ');
    }
  }
  if (room !== null && room !== void 0 && room.isMulticast || room !== null && room !== void 0 && room.isPersistent) name = room.name;
  return name;
});
var formatRoomName = (room, name) => {
  var {
    isMulticast,
    isPersistent,
    id
  } = room || {};
  if (name && !isMulticast && !isPersistent) {
    return _i18n.default.translate('room.list.unicast.with', {
      firstnames: name
    });
  }
  return name || _i18n.default.translate('room.fallbackName', {
    name: id || '?'
  });
};

// web
var getDisplayRoomNameSelector = exports.getDisplayRoomNameSelector = (0, _reselect.createSelector)([getRoomByIdSelector], room => formatRoomName(room, room === null || room === void 0 ? void 0 : room.name));

// mobile
var getDisplayRoomNameInListSelector = exports.getDisplayRoomNameInListSelector = (0, _reselect.createSelector)([getRoomByIdSelector, getDisplayRoomNameFromMembersSelector], formatRoomName);
var getMyClientAsARoomMemberSelector = exports.getMyClientAsARoomMemberSelector = (0, _reselect.createSelector)([getRoomByIdSelector, _selectors._currentClientSelector], (room, _client) => {
  if (!(room !== null && room !== void 0 && room.members)) return {};
  return room.members.find(el => el._client === _client) || {};
});
var getMeAsRoomMemberSelector = exports.getMeAsRoomMemberSelector = (0, _reselect.createSelector)([getRoomByIdSelector], room => {
  if (!(room !== null && room !== void 0 && room.members)) return {};
  return room.members.find(el => el.isMe) || {};
});
var getRoomMemberByUserIdSelector = exports.getRoomMemberByUserIdSelector = (0, _reselect.createSelector)([getRoomMembersByRoomIdSelector, _getUserParameter], (members, _user) => members === null || members === void 0 ? void 0 : members.find(member => (member === null || member === void 0 ? void 0 : member._user) === _user));
var getAwayRoomMemberIdsByRoomIdSelector = exports.getAwayRoomMemberIdsByRoomIdSelector = (0, _reselect.createSelector)([getAwayRoomMembersByRoomIdSelector], members => members === null || members === void 0 ? void 0 : members.map(_ref14 => {
  var {
    _user
  } = _ref14;
  return _user;
}));
var getRoomTypeByRoomIdSelector = exports.getRoomTypeByRoomIdSelector = (0, _reselect.createSelector)([_getRoomParameter, roomEntitiesSelector], (_room, rooms) => {
  var _rooms$_room3;
  return (_rooms$_room3 = rooms[_room]) !== null && _rooms$_room3 !== void 0 && _rooms$_room3.isVideoCall ? _constants.ROOM_TYPE.VIDEO : _constants.ROOM_TYPE.AUDIO;
});
var getRooms = exports.getRooms = (0, _reselect.createSelector)([_roomsSelector, roomEntitiesSelector], (_rooms, roomEntities) => {
  return _rooms.reduce((acc, _room) => {
    var roomData = roomEntities[_room];
    if (roomData) acc.push(roomData);
    return acc;
  }, []);
});
var _inProgressRooms = exports._inProgressRooms = (0, _reselect.createSelector)([_roomsSelector, roomEntitiesSelector], (_rooms, roomEntities) => {
  return _rooms.reduce((acc, _room) => {
    var roomData = roomEntities[_room];
    if (roomData !== null && roomData !== void 0 && roomData.inProgress) acc.push(_room);
    return acc;
  }, []);
});
var _notInProgressRooms = exports._notInProgressRooms = (0, _reselect.createSelector)([_roomsSelector, roomEntitiesSelector], (_rooms, roomEntities) => {
  return _rooms.reduce((acc, _room) => {
    var roomData = roomEntities[_room];
    if (!(roomData !== null && roomData !== void 0 && roomData.inProgress)) acc.push(_room);
    return acc;
  }, []);
});
var _inProgressUnicastRooms = exports._inProgressUnicastRooms = (0, _reselect.createSelector)([_inProgressRooms, roomEntitiesSelector], (_rooms, roomEntities) => {
  return _rooms.reduce((acc, _room) => {
    var _roomEntities$_room;
    if (!((_roomEntities$_room = roomEntities[_room]) !== null && _roomEntities$_room !== void 0 && _roomEntities$_room.isMulticast)) acc.push(_room);
    return acc;
  }, []);
});
var _inProgressMulticastRooms = exports._inProgressMulticastRooms = (0, _reselect.createSelector)([_inProgressRooms, roomEntitiesSelector], (_rooms, roomEntities) => {
  return _rooms.reduce((acc, _room) => {
    var _roomEntities$_room2;
    if ((_roomEntities$_room2 = roomEntities[_room]) !== null && _roomEntities$_room2 !== void 0 && _roomEntities$_room2.isMulticast) acc.push(_room);
    return acc;
  }, []);
});
var getRoomsLoaded = state => state.rooms.loaded;
exports.getRoomsLoaded = getRoomsLoaded;
var getUserIsAdminByCurrentUserIdSelector = exports.getUserIsAdminByCurrentUserIdSelector = (0, _reselect.createSelector)([getRoomByIdSelector, _selectors.getUserId], (room, _user) => {
  var _room$members;
  var user = room === null || room === void 0 || (_room$members = room.members) === null || _room$members === void 0 ? void 0 : _room$members.find(e => (e === null || e === void 0 ? void 0 : e._user) === _user);
  if (user) return user.isAdmin;
  return false;
});
var getWaitingRoomMembersByRoomIdSelector = exports.getWaitingRoomMembersByRoomIdSelector = (0, _reselect.createSelector)([getRoomMembersByRoomIdSelector], members => members === null || members === void 0 ? void 0 : members.filter(_ref15 => {
  var {
    status
  } = _ref15;
  return status === _constants.USER_IN_ROOM_STATUS.WAITING;
}));
var getFeedIdByRoomIdSelector = exports.getFeedIdByRoomIdSelector = (0, _reselect.createSelector)([getRoomByIdSelector], room => room === null || room === void 0 ? void 0 : room._feed);
var getRoomDisplayModeByRoomIdSelector = exports.getRoomDisplayModeByRoomIdSelector = (0, _reselect.createSelector)([getRoomByIdSelector], room => room === null || room === void 0 ? void 0 : room.displayMode);